import { navigateTo } from '#imports'

import { PaymentMarkName } from './performance/constant'
import { crossDomainMark } from './performance/crossDomainMark'

/**
 * navigateTo alias that handle performance measurement of the navigation to the payment page
 */
export const navigateToPaymentPage = async (
  ...args: Parameters<typeof navigateTo>
) => {
  crossDomainMark(PaymentMarkName.GoToPaymentClicked)
  await navigateTo(...args)
}
